import React, { useEffect, useState } from 'react';
import styles from './Checkbox.module.scss';
import Text from '../../Base/Text/Text';
import { joinClasses } from '../../../Utils/className.util';

interface ICheckbox {
	tx?: string;
	onChange?: (value: boolean) => void;
	onChangeExtra?: (value: boolean) => void;
	value?: boolean;
	firstUpper?: boolean;
	titleClassName?: string;
	disabled?: boolean;
	className?: string;
	checkClassName?: string;
	description?: string;
	beforeLabelElement?: React.ReactElement | React.ReactElement[];
}

export default function Checkbox(props: ICheckbox) {
	const {
		tx,
		onChange,
		onChangeExtra,
		titleClassName,
		value = false,
		firstUpper = false,
		disabled,
		className,
		checkClassName,
		description,
		beforeLabelElement,
	} = props;
	const [checked, setChecked] = useState(value);

	useEffect(() => {
		if (!disabled) {
			setChecked(value);
		}
	}, [value]);

	const handleClick = () => {
		if (!disabled) {
			const newValue = !value;
			onChange?.(newValue);
			onChangeExtra?.(newValue);
		}
	};

	return (
		<div
			className={joinClasses([
				styles.wrapper,
				disabled ? styles.disabled : undefined,
				className,
			])}
			onClick={handleClick}>
			<div
				className={joinClasses([
					styles.checkbox,
					checked && styles.active,
					checkClassName,
					className,
				])}
			/>
			{beforeLabelElement}
			<div>
				{tx && (
					<Text
						className={joinClasses([titleClassName, styles.title])}
						tx={tx}
						firstUpper={firstUpper}
					/>
				)}
				{description && <div className={styles.description}>{description}</div>}
			</div>
		</div>
	);
}
